/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { HchbTaskBody } from './HchbTaskBody';
import {
    HchbTaskBodyFromJSON,
    HchbTaskBodyFromJSONTyped,
    HchbTaskBodyToJSON,
} from './HchbTaskBody';

/**
 * 
 * @export
 * @interface StartExecutionRequest
 */
export interface StartExecutionRequest {
    /**
     * Facility ID
     * @type {string}
     * @memberof StartExecutionRequest
     */
    facilityId: string;
    /**
     * 
     * @type {HchbTaskBody}
     * @memberof StartExecutionRequest
     */
    taskBody: HchbTaskBody;
    /**
     * HCHB patient request ID
     * @type {string}
     * @memberof StartExecutionRequest
     */
    requestId: string;
    /**
     * Lead ID
     * @type {string}
     * @memberof StartExecutionRequest
     */
    leadId: string;
}

/**
 * Check if a given object implements the StartExecutionRequest interface.
 */
export function instanceOfStartExecutionRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "facilityId" in value;
    isInstance = isInstance && "taskBody" in value;
    isInstance = isInstance && "requestId" in value;
    isInstance = isInstance && "leadId" in value;

    return isInstance;
}

export function StartExecutionRequestFromJSON(json: any): StartExecutionRequest {
    return StartExecutionRequestFromJSONTyped(json, false);
}

export function StartExecutionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): StartExecutionRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'facilityId': json['facilityId'],
        'taskBody': HchbTaskBodyFromJSON(json['taskBody']),
        'requestId': json['requestId'],
        'leadId': json['leadId'],
    };
}

export function StartExecutionRequestToJSON(value?: StartExecutionRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'facilityId': value.facilityId,
        'taskBody': HchbTaskBodyToJSON(value.taskBody),
        'requestId': value.requestId,
        'leadId': value.leadId,
    };
}

